import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class DataService {
  private items: any[] = [];

  setItems(items: any[]) {
    this.items = items;
  }

  getItems() {
    return this.items;
  }

  getItemById(id: string) {
    return this.items.find(item => item.id == id);
  }
}
